import { Modal } from 'antd';
import styled from 'styled-components';
import { themeOptions } from 'variables/themes.js';

export const StyledAlertModal = styled(Modal)`
  .ant-modal-close {
    display: none;
  }

  .ant-modal-header {
    height: 40px;
    display: flex;
    align-items: center;

    .ant-modal-title {
      padding: 11px 20px 9px;
      color: #0e48ba;
      font-size: 14px;
      font-weight: 700;
    }
  }

  .ant-modal-content {
    position: relative;
    overflow: hidden;
    border-radius: 5px;

    &:after {
      content: '';
      position: absolute;
      top: -1px;
      left: 0;
      right: 0;
      height: 8px;
      border-radius: 5px 5px 0 0;
      z-index: 2;
      background: ${themeOptions.palette.primary.main};
    }
  }

  .ant-modal-body {
    padding: ${({ $hasTitle }) => ($hasTitle ? '29px 20px 25px;' : '40px 58px 14px;')};
    text-align: center;
    color: #333;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      top: ${({ $hasTitle }) => ($hasTitle ? '-37px' : '3px')};
      left: 0;
      right: 0;
      height: 5px;
      border-radius: 5px 5px 0 0;
      background: #fff;
      z-index: 3;
    }
  }

  .ant-modal-footer {
    padding: 20px;
    display: flex;
    justify-content: center;
    gap: 10px;

    > .ant-btn {
      width: 125px;
      height: 32px;
      border-radius: 2px;
    }

    ${({ $isSingleBtn }) =>
      $isSingleBtn
        ? `
        > .ant-btn:first-child {
          display: none;
        }

        > .ant-btn:last-child {
          width: 150px;
        }
      `
        : `
        > .ant-btn:first-child {
          background: #c1c4ce;
        }

        > .ant-btn:first-child > span {
          color: #4c4d56;
        }
      `}
  }
`;
